module.exports = __webpack_public_path__ + "static/logo-fh-061ad0492df86ba401ca5f813fe4d444.svg";